import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { DownloaderService } from '../../../shared/services/downloader.service';
import { ScwsService } from '../../services/scws-service.service';
import { SignatureSessionService } from '../../services/signature-session.service';
import { SpinnerService } from '../../../shared/services/spinner.service';
import { LogService } from '../../../shared/services/log.service';
import { from } from 'rxjs';
import 'brace';
import 'brace/mode/xml';
import 'brace/mode/html';
import { ShowOrHideSpinner } from 'src/app/modules/shared/models/showOrHideSpinner';
import { ShowOrHideComponent } from 'src/app/modules/shared/models/showOrHideComponent';
import { CommonService } from 'src/app/modules/shared/services/common.service';
import { DatePipe } from '@angular/common';
import { AnalysisMessages } from 'src/app/modules/shared/models/component-messages/analysis-messages';


@Component({
  selector: 'app-result',
  templateUrl: './result.component.html',
  styleUrls: ['./result.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ResultComponent extends ShowOrHideSpinner implements OnInit, OnDestroy, ShowOrHideComponent {

  public fileName;
  public showPreview = false;
  public content;
  public fileSize = '0';
  public fileType;
  public analysisMessage = new AnalysisMessages();

  constructor(private downloaderService: DownloaderService,
    private signatureSession: SignatureSessionService,
    private scwsService: ScwsService,
    private spinnerService: SpinnerService,
    private LOG: LogService,
    private commonService: CommonService) {
    super();
  }

  ngOnDestroy(): void {
    this.LOG.log('[SIGNATURE RESULT DESTROY]');
    this.signatureSession.clear();
  }

  ngOnInit() {
    this.LOG.log('[SIGNATURE SESSION : {0}]', JSON.stringify(this.signatureSession.signatureRequestData));
    if (this.signatureSession.scwsPkey === null
      || this.signatureSession.signatureCertificate === undefined
      || this.signatureSession.signatureRequestData.signatureTypeEnum === undefined) {
      return;
    }
    this.scwsService.getDataToSign(this.signatureSession.signatureCertificate.pem,
      this.signatureSession.signatureRequestData.documentToSign,
      this.signatureSession.signatureRequestData.signatureTypeEnum).subscribe(response => {
        this.signatureSession.signatureResponseData = response;
        const blob = this.scwsService.b64toBlob(response.dataToSign, 'application/octet-binary');
        from(this.signatureSession.scwsPkey.hashAndSign(blob, 'sha256')).subscribe((signatureValue: any) => {
          const base64String = btoa(String.fromCharCode.apply(null, new Uint8Array(signatureValue)));
          this.scwsService.sign(this.signatureSession.signatureCertificate.pem,
            base64String,
            this.signatureSession.signatureRequestData.documentToSign).subscribe(data => {
              this.signatureSession.signatureResponseData = data;
              this.fileName = this.getFileName();
              this.content = this.signatureSession.signatureResponseData.base64signedDocument;
              this.fileSize = this.base64Size(this.content);
              this.fileType = this.signatureSession.signatureResponseData.fileType;
              this.showPreview = true;
              this.hideSpinner(this.spinnerService);
            });
        });
      });
  }


  private getFileName(): string {
    const datePipe = new DatePipe('en-EN');
    let tempFileName = this.commonService.getFileNameWithAdditionalParameter(
      this.signatureSession.signatureRequestData.documentToSign.name,
      this.signatureSession.signatureRequestData.signatureTypeEnum
    );

    tempFileName = this.commonService.getFileNameWithAdditionalParameter(
      tempFileName,
      datePipe.transform(Date.now(), 'dd_MM_yyyy')
    );
    return tempFileName;
  }

  downloadFile() {
    // cas particulier dans le cas où le fichier est en format p7s 
    // l'extension n'est pas rajoutée automatiquement par le navigateur
    if (this.fileType === 'p7s') {
      this.fileName = this.fileName + '.p7s';
    }
    this.downloaderService.downloadFile(this.fileName,
      this.signatureSession.signatureResponseData.base64signedDocument,
      this.signatureSession.signatureResponseData.fileType);
  }

  showComponent() {
    return this.isSpinnerNotInProgress(this.spinnerService);
  }

  base64Size(base64: string) {
    return Math.round((base64.length * 3 / 4) / 1024) + '';
  }
}
